/* RESPONSIBLE TEAM: team-inbox-management */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';
import storage from 'embercom/vendor/intercom/storage';
import { inject as service } from '@ember/service';
import Range from 'embercom/models/reporting/range';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

const excludeLoading = [
  'apps.app.reports.overview',
  'apps.app.reports.old-overview',
  'apps.app.reports.views',
  'apps.app.reports.lead-generation',
  'apps.app.reports.customer-support',
  'apps.app.reports.outbound-engagement',
  'apps.app.reports.custom-reports',
];

export default class ReportsRoute extends Route {
  @service store;
  @service appService;
  @service reportingService;
  @service permissionsService;
  @service favoritesService;
  @service reportingFolderManagerService;
  @service reportingMetrics;
  @service reportingViews;
  @service reportingTemplates;
  @service reportAccessService;

  reportsForNavBar = [];
  @tracked showTemplateId = undefined;
  @tracked monitorId = undefined;

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-reporting',
    };
  }

  analytics = {
    section: 'reports',
  };
  titleToken = 'Reports';
  queryParams = {
    rangeEnd: { refreshModel: true },
    rangeStart: { refreshModel: true },
    showTemplateId: { refreshModel: false },
    monitorId: { refreshModel: false },
  };

  activate() {
    storage.set('lastProductUsed', 'reports');
  }

  loadPlatformData() {
    //setup platform
    let promises = [];
    //setup metrics, favorites
    if (this.reportingViews.canViewCustomReports) {
      promises.push(this.reportingTemplates.loadTemplates(this.monitorId));
      promises.push(
        this.reportingViews.setUp.perform().catch((error) => {
          if (error?.name === 'TaskCancelation') {
            return;
          }
          throw error;
        }),
      );
    }
    promises.push(this.reportingMetrics.setup.perform());
    promises.push(this.favoritesService.preloadFavorites.perform());
    promises.push(this.reportingFolderManagerService.loadFlexibleFolders());

    return Promise.all(promises);
  }

  async beforeModel(transition) {
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);

    if (transition.to.queryParams.embeddedContent) {
      this.controllerFor('apps/app').set('showPrimaryNav', false);
    }

    let { rangeStart, rangeEnd, showTemplateId, monitorId } = transition.to.queryParams;
    this.showTemplateId = showTemplateId;
    this.monitorId = monitorId;
    let range = Range.createFromParams(rangeStart, rangeEnd, this.appService.app.timezone);
    this.reportingService.set('range', range);
    this.preloadData ||= this.loadPlatformData();
    await this.preloadData;

    if (showTemplateId) {
      let existingReport = this.reportingViews.findBestReportForTemplate(showTemplateId);
      if (existingReport) {
        this.showTemplateId = undefined;
        this.replaceWith('apps.app.reports.custom-reports.report.show', existingReport.id, {
          queryParams: { showTemplateId: null },
        });
        return;
      }
    }
  }

  deactivate() {
    this.reportingFolderManagerService.resetFolders();
    this.reportingViews.shutDown();
  }

  @action
  loading(transition) {
    // This is a workaround to avoid breaking drag & drop within a report, which can trigger a transition
    if (
      transition.targetName === 'apps.app.reports.custom-reports.report.show.index' &&
      transition.from?.name === 'apps.app.reports.custom-reports.report.show.index'
    ) {
      return true;
    }

    if (excludeLoading.some((route) => transition.targetName.startsWith(route))) {
      return false;
    }
    return true;
  }
}
